import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

/**
 * PrivateRoute - Protects routes that require user authentication
 * Redirects to login if user is not authenticated
 * Preserves intended destination for post-login redirect
 */
const PrivateRoute = ({ children }) => {
  const { user, loading, isInitialized } = useSelector((state) => state.auth);
  const token = localStorage.getItem("token");
  const location = useLocation();

  // Show loading spinner while auth state is being determined
  if (!isInitialized || loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Check if user is authenticated
  if (!token || !user) {
    // Save the current location for redirect after login
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // User is authenticated, render the protected route
  return children;
};

export default PrivateRoute;
